import Styled from 'styled-components';

import { baseMixin } from '../../mixins';

const Wrapper = Styled.div`
  ${baseMixin};
`;

export { Wrapper };
